import { Flex, Text, Button, theme } from '../../../2022-component-library';
import { useCalibration } from '../../../context/calibrationContext';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useMediaQuery } from '../../../helpers/useMediaQuery';

const StyledValueReadout = styled(Flex)`
  border: 1px solid #d6e4ec;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.validValue ? theme.colors.success : theme.colors.backgroundShade)};
  border-radius: 4px;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  padding: 0.7rem 1.3rem;
  color: ${(props) => (props.validValue ? '#fff' : '#000')};
`;

const ResponsiveScreenCalibrationReadout = ({ patientValuesReceived, calibrationMethod, setActiveTab }) => {
  const { updateCalibrationData, calibrationData } = useCalibration();
  const [height, setHeight] = useState(null);
  const [width, setWidth] = useState(null);
  const smallScreen = useMediaQuery('(max-width: 700px)');

  useEffect(() => {
    if (patientValuesReceived) {
      const dimensionsToUse = calibrationData[`${calibrationMethod}Dimensions`];
      if (calibrationMethod === 'card') {
        setHeight(dimensionsToUse.height);
        setWidth(dimensionsToUse.widthPx);
      } else {
        setHeight(dimensionsToUse.heightMm);
        setWidth(dimensionsToUse.widthMm);
      }
    }
  }, [calibrationData, calibrationMethod, patientValuesReceived]);

  return (
    <Flex column centered padding='2rem'>
      <Flex centered marginBottom='4rem'>
        <Flex column centered marginRight='5rem'>
          <Text size={!smallScreen ? 'h2' : undefined} textAlign='center' marginBottom='1rem'>
            Patient Device Height
          </Text>
          <StyledValueReadout width='7.5rem' validValue={patientValuesReceived}>
            <Text size='subHeading'>{height ? `${height.toFixed()}mm` : '--'}</Text>
          </StyledValueReadout>
        </Flex>
        <Flex column centered>
          <Text size={!smallScreen ? 'h2' : undefined} textAlign='center' marginBottom='1rem'>
            Patient Device Width
          </Text>
          <StyledValueReadout width='7.5rem' validValue={patientValuesReceived}>
            <Text size='subHeading'>{width ? `${width.toFixed()}mm` : '--'}</Text>
          </StyledValueReadout>
        </Flex>
      </Flex>
      <Text marginBottom='2rem' visibility={`${patientValuesReceived ? 'visible' : 'hidden'}`}>
        Patient has submitted values.
      </Text>
      <Button
        width='50vw'
        disabled={!patientValuesReceived}
        onClick={() => {
          updateCalibrationData({ screenCalibrated: true });
          return setActiveTab('calibration-selection');
        }}
      >
        Confirm
      </Button>
    </Flex>
  );
};

export default ResponsiveScreenCalibrationReadout;
